import { render, staticRenderFns } from "./step01.vue?vue&type=template&id=2d681666&scoped=true"
import script from "./step01.vue?vue&type=script&lang=js"
export * from "./step01.vue?vue&type=script&lang=js"
import style0 from "./step01.vue?vue&type=style&index=0&id=2d681666&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d681666",
  null
  
)

export default component.exports